import { Col, Flex, Grid, Row, Typography } from "antd";
import { Outlet } from "react-router-dom";
import Footer from "../../components/v2/Footer/Footer";
import style from "./ChangePassword.module.css";

const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

export default function ChangePassword() {
  const screen = useBreakpoint();

  return (
    <>
      <Row style={{ minHeight: "calc(100vh - 46px)" }} align="top">
        <Col
          xs={{ span: 22, offset: 1 }}
          lg={{ span: 9, offset: 0 }}
          className={style.Left}
        >
          <Row align={{ sm: "middle", lg: "top" }} style={{ height: "100%" }}>
            <Col
              xs={{ span: 24, offset: 0 }}
              md={{ span: 15, offset: 1 }}
              lg={{ span: 15, offset: 2 }}
              xl={{ offset: 6 }}
              style={{
                padding:
                  screen.xs || (screen.md === true && screen.lg === false)
                    ? "30px 20px"
                    : "unset",
              }}
            >
              <Title
                level={screen.xs ? 3 : 2}
                style={{
                  margin: 0,
                  color: "#1c2e5c",
                  lineHeight: 1,
                  textAlign: screen.xs ? "center" : "start",
                }}
              >
                Powering your snack & drink delivery business
                <Text style={{ color: "#f7ca0f", fontSize: "inherit" }}>.</Text>
              </Title>
              <Paragraph
                style={{
                  margin: 0,
                  textAlign: screen.xs ? "center" : "start",
                  fontSize: screen.xs ? "inherit" : "16px",
                }}
              >
                We simplify your delivery business by providing access to top
                delivery apps from one user-friendly platform.
              </Paragraph>
            </Col>
          </Row>
        </Col>
        <Col
          xs={{ span: 22, offset: 1 }}
          md={{ span: 12, offset: 6 }}
          lg={{ span: 7, offset: 4 }}
          className={style.Right}
        >
          <Flex vertical style={{ height: "100%" }}>
            <div style={{ flex: 1 }}>
              <Flex
                vertical
                align="center"
                justify="center"
                style={{
                  height: "100%",
                }}
              >
                <Outlet />
              </Flex>
            </div>

            <Paragraph
              style={{
                marginTop: "5rem",
                marginBottom: "3.75rem",
                textAlign: "center",
              }}
            >
              For any questions, contact us at{" "}
              <a href="mailto:support@bevz.com">support@bevz.com</a>
            </Paragraph>
          </Flex>
        </Col>
      </Row>
      <Footer />
    </>
  );
}
